import { Routes } from '@angular/router';
import { authGuard } from 'src/lib/guards/auth.guard';

export const sendEmailRoutes: Routes = [
  {
    path: 'send-email',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './components/smart/send-email-page/send-email-page.component'
      ).then((m) => m.SendEmailPageComponent),
  },
];
